import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, FolderKanban } from "lucide-react";

export default function Projects() {
  const [projects, setProjects] = useState(null);
  useEffect(() => { api.get("/projects").then((r) => setProjects(r.data)).catch(() => setProjects([])); }, []);

  if (!projects) return <div className="flex justify-center h-96 items-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display font-extrabold text-3xl text-white tracking-tight">Projects & Topics</h1>
        <p className="text-slate-400 mt-2">Every major body of work, assembled automatically from its supporting files.</p>
      </div>
      {projects.length === 0 ? (
        <div className="rounded-xl border border-white/5 bg-[#111827] p-16 text-center text-slate-500">
          <FolderKanban className="w-10 h-10 mx-auto mb-4 text-slate-700" />
          No projects yet. Upload material and the AI will create project pages automatically.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((p, i) => (
            <Link key={p.id} to={`/project/${p.id}`} data-testid={`project-${p.id}`} className="group rounded-xl overflow-hidden border border-white/5 bg-[#111827] hover:border-blue-500/30 hover:-translate-y-1 transition-transform transition-colors duration-300 fade-up" style={{ animationDelay: `${i * 50}ms` }}>
              <div className="relative h-36 overflow-hidden">
                <img src={p.cover_image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-70 group-hover:scale-105 group-hover:opacity-90 transition-all duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#111827] to-transparent" />
                <span className="absolute top-3 left-3 text-[10px] uppercase tracking-widest text-blue-300 bg-blue-600/20 border border-blue-500/30 rounded-full px-2.5 py-0.5">{p.type}</span>
              </div>
              <div className="p-5">
                <h3 className="font-display font-semibold text-white group-hover:text-blue-300 transition-colors leading-snug">{p.name}</h3>
                <div className="text-xs text-slate-500 mt-2">{p.file_count} supporting file(s)</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
